module.exports = __webpack_public_path__ + "img/img-mentions.9305de16.png";